import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { hideSquadModal } from '../../actions/squad';

import './SquadModal.css';

class SquadModal extends React.Component {
  static propTypes = {
    // Redux State.
    squadModal: PropTypes.shape({
      name: PropTypes.string,
      img: PropTypes.string,
      desc: PropTypes.string,
      backgroundImg: PropTypes.string,
      backgroundStyle: PropTypes.object,
    }),

    // Redux Dispatch.
    hideSquadModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    squadModal: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      show: props.squadModal !== null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: nextProps.squadModal !== null,
    });
  }

  onExited = () => {
    this.props.hideSquadModal();
  };

  onHide = () => {
    this.setState({ show: false });
  };

  render() {
    const { show } = this.state;
    const { squadModal } = this.props;
    const {
      name, img, desc, backgroundImg, backgroundStyle,
    } = squadModal || {};

    return (
      <Modal
        dialogClassName="squad-modal"
        onExited={this.onExited}
        onHide={this.onHide}
        show={show}
      >
        <Modal.Body>
          <div className="background-image-wrapper">
            <div className="background-image">
              <img src={backgroundImg} alt="" style={backgroundStyle} />
            </div>
            <div className="row">
              <div className="col-xs-offset-4 col-xs-4">
                <div className="image">
                  <img className="img-circle img-responsive full-width" src={img} alt="" />
                </div>
              </div>
            </div>
          </div>
          <button type="button" className="close" onClick={this.onHide}>
            <span aria-hidden>&times;</span>
          </button>
          <div className="content-wrapper">
            <div className="content">
              <div className="row">
                <div className="col-xs-12">
                  <h2>{name}</h2>
                  <p>{desc}</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const { squadModal } = state;
  return {
    squadModal,
  };
};

const mapDispatchToProps = {
  hideSquadModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(SquadModal);



// WEBPACK FOOTER //
// ./src/containers/SquadModal/index.js